import { Component } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

import { MAILUPDATEVIEWLABELS, SHAREDCONSTANTS } from '../../_constants/constants';
import { CustomerService } from '../../_services/customer.service';

import { NotificationDialogComponent } from './../../notification/notification.dialog.component';

import { TranslatePipe } from '../../shared/translate/translate.pipe';

export interface MailupdateModel {
    title: string;
    // current_address_label: string;
    // new_address_label: string;
    description: string;
    oldMail: string;
    subValue: string;
    opcoValue: string;
    customerService: CustomerService;
}

@Component({
    templateUrl: 'mail.update.dialog.component.html',
    providers: [TranslatePipe]
})

export class MailupdateComponent extends DialogComponent<MailupdateModel, string> implements MailupdateModel {
    subValue: string;
    opcoValue: string;
    title: string;
    // new_address_label = 'New Email';
    // current_address_label = 'Current Email';
    oldMail: string;
    newMail: string;
    description: string;
    mailupdateviewlabels = MAILUPDATEVIEWLABELS;
    customerService: CustomerService;
    requiredErrorMsg:string = "";

    isSameMailError: boolean = false;
    sameMailErrorMsg = "";

    constructor(private ds: DialogService, private translatePipe: TranslatePipe) {
        super(ds);

        this.requiredErrorMsg = this.translatePipe.transform("REQUIRED_FIELD",'CLIENT_SIDE_VALIDATION_ERROR');

        this.isSameMailError = false;
        this.sameMailErrorMsg = "";
    }

    setCustomValidity(event){  
    
        if (event.target.value === '') {
            event.target.setCustomValidity(this.translatePipe.transform("REQUIRED_FIELD",'CLIENT_SIDE_VALIDATION_ERROR'));
        } else if (event.target.validity.typeMismatch || event.target.validity.patternMismatch) {
            event.target.setCustomValidity(this.translatePipe.transform("INVALID_EMAIL_ADDRESS",'CLIENT_SIDE_VALIDATION_ERROR'));
        } else {
           event.target.setCustomValidity('');
        }

        return true;          
    } 

    setCustomValidityBlank(event) {
        event.target.setCustomValidity('');
    }

    mouseHover(event) {

        event.target.setAttribute("title", "");

        // if (event.target.value == "") {
        //     event.target.setAttribute("title", this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR'))
        // }
        // else {
        //     event.target.setAttribute("title", "")
        // }
    }   

    keyDownEvent(e){

        if (e.which === 32)
            e.preventDefault();
        
        this.isSameMailError = false;
        this.sameMailErrorMsg = "";
    }  

    apply(formData: any) {
        if (!(this.newMail) || (this.newMail === null) || (this.newMail.trim() == "") || (this.newMail === undefined)) {

            formData.form.controls['newMailUpdate'].markAsDirty();
            formData.form.controls['newMailUpdate'].markAsTouched();
            formData.form.controls['newMailUpdate'].setErrors({ 'required': true });
            return;
        }
        if(this.newMail.trim().toLowerCase() === this.oldMail.trim().toLowerCase()){

            this.isSameMailError = true;
            this.sameMailErrorMsg = this.translatePipe.transform("SAME_EMAIL_EXCEPTION", 'SHAREDCONSTANTS');

            // this.close();  
            // this.ds.addDialog(NotificationDialogComponent, {
            //     success: false,
            //     message: this.translatePipe.transform("SAME_EMAIL_EXCEPTION",'SHAREDCONSTANTS')
            // });            
            return;
        }
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.newMail.trim().toLowerCase())){}
        else{
            this.isSameMailError = true;
            this.sameMailErrorMsg = this.translatePipe.transform('INVALID_EMAIL_ADDRESS', 'CLIENT_SIDE_VALIDATION_ERROR')           
            return;
        }

        this.customerService.updateMail(this.newMail, this.subValue, this.opcoValue, this.ds);
        this.close();
    }
}




// WEBPACK FOOTER //
// ./src/app/details/mailupdate/mail.update.dialog.component.ts